<template>
    <v-dialog max-width="450" persistent v-model="dialog">
        <v-card v-if="showConfirmationDialog">
            <v-card-title class="headline">Confirmation</v-card-title>
            <v-card-text>
                <v-card>
                    <v-card-text>
                        <p>GFI Scores for this customer has been generated already. Please confirm you want to change the details for this customer. Please note that doing so will remove the current scores and new
                        score will have to be generated.</p>
                        <p>Do you want to proceed ?</p>
                        <v-card-actions>
                            <v-btn class="primary" @click="destroy" >Cancel</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn class="primary" @click="hideConfirmationDialog">Confirm</v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
        <v-card v-else>
            <v-card-title class="headline">Edit Customer Information</v-card-title>
            <v-card-text>
                <ValidationObserver ref="observer" v-slot="{failedRules, failed ,passes}">
                    <form>
                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider vid="applicationNumber" name="applicationNumber"
                                                :rules="{required : true, min:3, max:25, regex:/^[a-zA-Z0-9-]+$/ }"
                                                ref="observerEditApplicationNumber"
                                                v-slot="{errors, failedRules}">
                                <v-text-field :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                                              class="requiredSticker" readonly disabled
                                              label="Application Number" v-model="customer.applicationNumber"></v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                      <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                        <ValidationProvider vid="customerId" name="customerId"
                                            :rules="{required : true, min:3, max:25, regex:/^[a-zA-Z0-9-]+$/ }"
                                            v-slot="{errors, failedRules}">
                          <v-text-field :error-messages="$translatedErrorMessages(failedRules,'customerId')"
                                        class="requiredSticker" readonly disabled
                                        label="Customer ID" v-model="customer.customerId"></v-text-field>
                        </ValidationProvider>
                      </v-skeleton-loader>

                        <v-skeleton-loader
                                :loading="loading"
                                transition="scale-transition"
                                type="list-item-two-line">
                            <v-select :error-messages="$translatedErrorMessages(failedRules,'businessCategory')"
                                      class="requiredSticker"
                                      :items="dropdown.businessCategories"
                                      item-text="text"
                                      item-value="value"
                                      label="Business Category"
                                      v-model="customer.businessCategory"
                            ></v-select>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider :rules="{required : true}" name="product"
                                                v-slot="{ errors, failedRules }">
                                <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'product')"
                                                readonly
                                                :items="$parent.filters.scheme"
                                                item-text="label"
                                                item-value="code"
                                                label="Product Applied"
                                                v-model="customer.productApplied"
                                ></v-autocomplete>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider
                                    :rules="{ required: true, numeric: true, min_value: selectedProduct.validation.minAmount, max_value : selectedProduct.validation.maxAmount}"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'financingAmount', [selectedProduct.validation.minAmount, selectedProduct.validation.maxAmount])"
                                        class="requiredSticker"
                                        label="Financing Amount Applied"
                                        prefix="$"
                                        v-model="customer.loanAmount">
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>

                        <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                            <ValidationProvider
                                    :rules="{ required: true, numeric: true, min_value: selectedProduct.validation.minTenure, max_value : selectedProduct.validation.maxTenure}"
                                    v-slot="{errors, failedRules}">
                                <v-text-field
                                        :error-messages="$translatedErrorMessages(failedRules,'tenureApplied', [selectedProduct.validation.minTenure, selectedProduct.validation.maxTenure])"
                                        class="requiredSticker"
                                        label="Financing Tenure Applied"
                                        required
                                        suffix="Months"
                                        v-model="customer.tenureApplied">
                                </v-text-field>
                            </ValidationProvider>
                        </v-skeleton-loader>
                        <div>
                            <div v-show="failed">
                                <p style="color:red" >One or more customer information have errors, please provide correct information to save successfully</p>
                            </div>
                            <div v-show="serverError">
                                <p style="color:red" >Something went wrong. Please try again later</p>
                            </div>
                        </div>
                        <v-card-actions align="right">
                            <v-spacer></v-spacer>
                            <v-skeleton-loader class="mr-3" :loading="loading||sending" transition="scale-transition" type="button">
                                <v-btn @click="destroy" color="primary">Cancel</v-btn>
                            </v-skeleton-loader>
                            <v-skeleton-loader :loading="loading||sending" transition="scale-transition" type="button">
                                <v-btn @click="passes(saveCustomer)" color="primary" dark>Save
                                </v-btn>
                            </v-skeleton-loader>
                        </v-card-actions>
                    </form>
                </ValidationObserver>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import {ValidationObserver, ValidationProvider} from 'vee-validate';
    import {dataServices} from "@/services";

    export default {
        name: 'CustomerMaintenance',
        components: {
            ValidationProvider,
            ValidationObserver
        },
        data() {
            return {
                loading: false,
                dialog: false,
                menu: false,
                customer: {},
                dropdown: {},
                branches:[],
                date: new Date().toISOString().substr(0, 10),
                editedCommencementDate:'',
                editBusinessCategoryDropdownData: [],
                validation: false,
                selectedProduct: {
                    validation: {
                        minAmount: 500,
                        maxAmount: 999999999,
                        minTenure: 3,
                        maxTenure: 120
                    }
                },
                malaysianOwnedItems: [
                    {text: 'Yes', value: 'Yes'},
                    {text: 'No', value: 'No'}
                ],
                errors: [],
                showConfirmationDialog: false,
                failed: false,
                serverError: false,
                sending: false
            }
        },
        methods: {
            init(customer, validation) {
                this.loading = true
                this.customer = Object.assign({}, customer)
                this.validation = validation
                if (this.customer.gfiScoreGenerationCount === null || (this.customer.gfiScoreGenerationCount > 0 && !this.customer.hasGfiScore) ){
                    this.showConfirmationDialog = false
                } else if(this.customer.gfiScoreGenerationCount === 1) {
                    this.showConfirmationDialog = true
                }
                this.initDropdown()
                this.dialog = true
            },
            initDropdown: function () {
                dataServices.getUserDropDowns(this.$parent.userType.toUpperCase()).then(response => {
                    this.dropdown = response.dataResponse
                    this.branches = response.dataResponse.branch
                    this.loading = false
                })
            },
            saveCustomer() {
                this.sending=true
                dataServices.saveCustomer(this.customer).then(r => {
                    this.sending=false
                    if (r.successful) {
                        this.$parent.renderMessage('Successfully updated customer information.')
                        this.dialog = false
                    } else {
                        r.errorList.forEach(e => {
                            if(e.field==='applicationNumber' && e.rule==='duplicate'){
                                this.$refs.observerEditApplicationNumber.applyResult({
                                    errors: ['error'],
                                    failedRules: ['duplicate']
                                });
                            }
                        })
                    }
                }).catch(error => {
                    this.sending=false
                    this.serverError = true
                    console.log('Error' + error)
                })
            },
            hideConfirmationDialog() {
                this.showConfirmationDialog = false
            },
            destroy() {
                this.dialog = false
            }
        },
        watch: {
            'customer.commencementDate': function () {
                if (this.customer.commencementDate) {
                    const [year, month, day] = this.customer.commencementDate.substr(0, 10).split('-')
                    this.editedCommencementDate = `${day}-${month}-${year}`
                } else
                    this.editedCommencementDate = ''
            },
            editedCommencementDate: function (newCommencementDate) {
                if (!newCommencementDate) {
                    this.customer.commencementDate = null
                }
            },
        }
    }
</script>

<style>
    .requiredSticker label::after {
        content: "*";
        color: red;
    }
</style>
